import filter from "../../assets/Accessories/Filter.jpeg";
import gasket from "../../assets/Accessories/Gasket.jpeg";
import valve from "../../assets/Accessories/Valve.jpeg";
import accesories2 from "../../assets/Accessories/accessories-2.jpeg";
import gloves from "../../assets/Accessories/gloves.jpeg";
import lid from "../../assets/Accessories/lid.jpeg";
import lid2 from "../../assets/Accessories/lid2.jpeg";
import sealBelt from "../../assets/Accessories/seal_belt.jpeg";
import spikeBoard from "../../assets/Accessories/spike_board.jpeg";

import gb2 from "../../assets/Product_img/gb_II/1.jpg";
import gb3 from "../../assets/Product_img/gb_III/1.jpeg";
import gb4 from "../../assets/Product_img/gb_IV/1.jpg";
import gbcustom from "../../assets/Product_img/gb_custom/1.jpg";

import profPic2 from "../../assets/profile_img/img.png";

export const ProductData = {
  heroData: {
    title: "Our ",
    title2: "Products",
    subTitle: "Advanced Glovebox Systems for Controlled Atmosphere Applications",
    imgUrl:
      gbcustom
  },

  productCardList: {
    title: "Glovebox Product Portfolio",
    description:
      "ProRes Scientific designs and manufactures high-performance inert atmosphere glovebox systems engineered for research laboratories, pilot plants, and industrial environments requiring ultra-low oxygen and moisture control.",

    list: [
      {
        id: 1,
        title: "Pro-Lab GB II",
        tagline: "Compact Single-Station Inert Atmosphere Glovebox",
        description:
          "Pro-Lab GB II is a space-efficient glovebox system designed for air-sensitive material handling. Ideal for academic labs and R&D facilities requiring stable oxygen and moisture levels below 1 ppm.",
        img: gb2,
        serviceCategory:"proLabGB2",
        ctaText:"See Details",
        ctaUrl:"prolab-gb-2"
      },
      {
        id: 2,
        title: "Pro-Lab GB III",
        tagline: "Dual-Station Research Grade Glovebox",
        description:
          "Pro-Lab GB III offers expanded workspace with dual glove ports and enhanced purification capacity. Suitable for advanced material synthesis, battery research, and continuous experimental workflows.",
        img: gb3,
        serviceCategory:"proLabGB3",
        ctaText:"See Details",
        ctaUrl:"prolab-gb-3"
      },
      {
        id: 3,
        title: "Pro-Lab GB IV",
        tagline: "High-Capacity Industrial Research Glovebox",
        description:
          "Designed for demanding research and pilot-scale operations, Pro-Lab GB IV features large working volume, high-throughput purification system, and robust stainless-steel construction.",
        img: gb4,
        serviceCategory:"proLabGB4",
        ctaText:"See Details",
        ctaUrl:"prolab-gb-4"
      },
      {
        id: 4,
        title: "Pro-Lab GB Custom",
        tagline: "Fully Customized Controlled Atmosphere Systems",
        description:
          "Custom-engineered glovebox solutions tailored to specific applications including lithium battery manufacturing, nuclear research, pharmaceutical synthesis, and additive manufacturing.",
        img: gbcustom,
        serviceCategory:"proLabGBCustom",
        ctaText:"See Details",
        ctaUrl:"prolab-gb-custom"
      },
      // {
      //   id: 5,
      //   title: "Key Features & Technology",
      //   tagline: "Precision Engineering Across All Models",
      //   description:
      //     "All ProRes gloveboxes feature advanced gas purification, automated pressure control, leak-tight construction, modular expansion capability, and real-time oxygen and moisture monitoring.",
      //   img: "https://proresglovebox.com/wp-content/uploads/2024/06/key-features.jpg",
      // },
    ],
  },

  Accessories: {
    title: "Certified Accessories & Spare Parts",
    subTitle: "Compatible Components for ProRes Glovebox Systems",

    accList: [
      {
        title: "Gloves",
        img: gloves,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Filter",
        img: filter,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Gasket",
        img: gasket,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Valve",
        img: valve,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Lid",
        img: lid2,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Accessories",
        img: accesories2,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Seal Belt",
        img: sealBelt,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Spike Board",
        img: spikeBoard,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Lid",
        img: lid,
        oldPrice: "",
        newPrice: "",
      },
    ],
  },

  testimonials: {
    title: "Client Experiences",
    subTitle: "RESEARCH & INDUSTRY FEEDBACK",

    testimonialList: [
      {
        title: "Advanced Battery Research",
        description:
          "The Pro-Lab GB IV system consistently maintains ultra-low oxygen levels, enabling us to achieve reproducible solid-state battery results.",
        name: "Dr. Anil Kumar",
        role: "Senior Research Scientist",
        image: profPic2
      },
      {
        title: "Pharmaceutical R&D",
        description:
          "ProRes custom glovebox allowed safe handling of air-sensitive intermediates, significantly improving product stability and yield.",
        name: "Rohit Mehta",
        role: "Process Development Lead",
        image: profPic2
      },
    ],
  },
};
